module.exports = __webpack_public_path__ + "img/17876_L.9d34a48f.png";